var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var PartnersApi = /** @class */function () {
  function PartnersApi(client) {
    this.client = client;
    this.path = '/api/v1/partners';
    this.v2Path = '/api/v2/partners';
  }
  PartnersApi.prototype.getPartnerByEmail = function (email) {
    return __awaiter(this, void 0, Promise, function () {
      var data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4 /*yield*/, this.client.get({
              url: "".concat(this.path, "/find/").concat(email),
              operation: 'get-rm-partner-by-email'
            })];
          case 1:
            data = _a.sent().data;
            return [2 /*return*/, __assign(__assign({}, data.body), {
              partnerId: data.body.metadata['resourceUri'].split('/')[2]
            })];
        }
      });
    });
  };
  PartnersApi.prototype.getPartnerPrograms = function (email) {
    return __awaiter(this, void 0, Promise, function () {
      var partnerId, data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4 /*yield*/, this.getPartnerByEmail(email)];
          case 1:
            partnerId = _a.sent().partnerId;
            return [4 /*yield*/, this.client.get({
              url: "".concat(this.path, "/").concat(partnerId, "/programs"),
              operation: 'get-partner-programs'
            })];
          case 2:
            data = _a.sent().data;
            return [2 /*return*/, data.body];
        }
      });
    });
  };
  PartnersApi.prototype.getVanityHandle = function (partnerId) {
    return __awaiter(this, void 0, Promise, function () {
      var data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4 /*yield*/, this.client.get({
              url: "".concat(this.path, "/").concat(partnerId, "/vanity-handle"),
              operation: 'get-vanity-handle'
            })];
          case 1:
            data = _a.sent().data;
            return [2 /*return*/, data];
        }
      });
    });
  };
  PartnersApi.prototype.getAccountConnectionDetails = function (partnerId) {
    return __awaiter(this, void 0, Promise, function () {
      var data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4 /*yield*/, this.client.get({
              // not sure why this doesn't use a versioned path
              url: "/api/partners/".concat(partnerId, "/accountConnectionDetails"),
              operation: 'get-account-connection-details'
            })];
          case 1:
            data = _a.sent().data;
            return [2 /*return*/, data];
        }
      });
    });
  };
  PartnersApi.prototype.generateAppDeeplink = function (rmPartnerId, brand) {
    return __awaiter(this, void 0, Promise, function () {
      var data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4 /*yield*/, this.client.post({
              url: "".concat(this.v2Path, "/generate-app-deeplink"),
              operation: 'generate-app-deeplink',
              config: {
                data: {
                  rmPartnerId: rmPartnerId,
                  brand: brand
                }
              }
            })];
          case 1:
            data = _a.sent().data;
            return [2 /*return*/, data.body];
        }
      });
    });
  };
  return PartnersApi;
}();
export { PartnersApi };